import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-74dcaa44"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "self_label"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    class: "adorn"
  }, null, -1);
});

var _hoisted_3 = {
  class: "label_title"
};
var _hoisted_4 = {
  class: "textarea"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_UpLoadImg = _resolveComponent("UpLoadImg");

  var _component_el_form = _resolveComponent("el-form");

  return _openBlock(), _createBlock(_component_el_form, {
    ref: "ruleFormRef",
    class: "window",
    model: _ctx.form,
    rules: _ctx.rules
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1)]), _createVNode(_component_el_form_item, {
        prop: "content"
      }, {
        default: _withCtx(function () {
          return [!_ctx.form.content && _ctx.iconFlag ? (_openBlock(), _createBlock(_component_el_image, {
            key: 0,
            class: "iconFlag",
            src: require('@/assets/img/comment.png')
          }, null, 8, ["src"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
            modelValue: _ctx.form.content,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.form.content = $event;
            }),
            class: "dealContent",
            placeholder: "     请填写描述",
            maxlength: "100",
            "show-word-limit": "",
            resize: "none",
            "input-style": {
              height: '100px'
            },
            type: "textarea",
            onCompositionstart: _ctx.startInput,
            onCompositionend: _ctx.endInput
          }, {
            prepend: _withCtx(function () {
              return [];
            }),
            _: 1
          }, 8, ["modelValue", "onCompositionstart", "onCompositionend"])])];
        }),
        _: 1
      }), _createVNode(_component_UpLoadImg, {
        ref: "uploadRef",
        style: {
          "margin-top": "25px"
        },
        limit: 9,
        onFile: _ctx.filechange
      }, null, 8, ["onFile"])];
    }),
    _: 1
  }, 8, ["model", "rules"]);
}